import axios from "./index.service";

export default class AnnouncementService {
  static create(payload) {
    console.log({ payload });
    return axios({
      method: "POST",
      url: "/api/services/v1/announcement/",
      data: payload,
    });
  }

  static fetchAll(pageAble) {
    return axios({
      method: "GET",
      url: "/api/services/v1/announcement/list-all",
      params: pageAble,
    });
  }

  static fetchById(pageAble, announcementId) {
    return axios({
      method: "GET",
      url: `/api/services/v1/announcement/${announcementId}`,
      params: pageAble,
    });
  }

  static update(announcementId) {
    return axios({
      method: "PUT",
      url: `/api/services/v1/announcement/${announcementId}`,
    });
  }

  static delete(announcementId) {
    return axios({
      method: "DELETE",
      url: `/api/services/v1/announcement/${announcementId}`,
    });
  }

  static approveOrDisapprove(payload) {
    const { id, action } = payload;
    const apiAction = action === "approve" ? "approve" : "disapprove";
    console.log({ apiAction });
    return axios({
      method: "PUT",
      url: `/api/services/v1/announcement/${apiAction}/${id}`,
    });
  }
}
